import * as tslib_1 from "tslib";
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../../../core/decorators/auto-unsubscribe';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SmsService } from '../../../modulos/general/componentes/gestion-terceros/servicios/sms.service';
import { AuthService } from '../../../../core/services/auth.service';
import { ChildsMenuEnum } from '../../../../core/enums/childs-menu.enum';
let ModalPhoneComponent = class ModalPhoneComponent {
    constructor(translateService, toastr, _globals, _authService, _smsService) {
        this.translateService = translateService;
        this.toastr = toastr;
        this._globals = _globals;
        this._authService = _authService;
        this._smsService = _smsService;
        this._datosSMS = {
            fechaEntrega: new Date(),
            importe: 0,
            importeSinIva: 0,
            marca: '',
            matricula: '',
            nombre: '',
            razonSocial: '',
            vin: ''
        };
        this.childModalClose = new EventEmitter();
        this.contadorCaracteres = 0;
    }
    set datosSMS(value) {
        this._datosSMS = value;
    }
    ngOnInit() {
        this.customerId = this._authService.getCustomerId();
        this.clientCode = this._authService.getClientCode();
        this.companyCode = this._authService.getCompanyCode();
        this.fechaActual = this._globals.getDateFormatForServerNow();
        // this.crearForm();
        this.getTemplates();
    }
    getTemplates() {
        this._smsService.getComboTypeSms().subscribe(resp => {
            this.templateList = resp.Response;
            this.prepareSMS();
        });
    }
    prepareSMS() {
        let smsText = '';
        const template = this.templateList.filter(template => {
            return template.TemplateCode == 'CLOSEOR';
        })[0];
        let text = template.Text;
        const sms = this._datosSMS;
        template.MessageTemplateFieldsList.forEach(field => {
            // TODO: eliminar '@@CGCompany', '@@CGPlate', '@@ORTotalAmount', '@@CGBrand', '@@ORPreviewedDate' cuando se aplique la unificacion de plantillas de DRA-8627
            switch (field.FieldCode) {
                case '@@ORCompany':
                case '@@CGCompany':
                    text = text.replaceAll(field.FieldCode, sms.razonSocial);
                    break;
                case '@@ORCustomerName':
                    text = text.replaceAll(field.FieldCode, sms.nombre);
                    break;
                case '@@ORPlate':
                case '@@CGPlate':
                    text = text.replaceAll(field.FieldCode, sms.matricula);
                    break;
                case '@@ORVin':
                    text = text.replaceAll(field.FieldCode, sms.vin);
                    break;
                case '@@ORTotalWithIVA':
                    text = text.replaceAll(field.FieldCode, sms.importe);
                    break;
                case '@@ORTotalAmount':
                    text = text.replaceAll(field.FieldCode, sms.importeSinIva);
                    break;
                case '@@CGBrand':
                    text = text.replaceAll(field.FieldCode, sms.marca);
                    break;
                case '@@ORPreviewedDate':
                    text = text.replaceAll(field.FieldCode, this._globals.getDateFormatMDY(sms.fechaEntrega));
                    break;
            }
        });
        smsText += `${text}\n`;
        this.crearForm(smsText);
    }
    crearForm(text) {
        if (text) {
            this.contadorCaracteres = text.length;
        }
        this.formSms = new FormGroup({
            Phone: new FormControl(this.TelephonePortable ? this.TelephonePortable : '', [Validators.required, Validators.maxLength(11)]),
            Description: new FormControl(text, Validators.required)
        });
        this.subs2 = this.formSms.get('Description').valueChanges.subscribe(val => {
            if (val !== '') {
                this.contadorCaracteres = val.length;
            }
        });
    }
    closeModal(conDatos) {
        if (conDatos) {
            if (this.validateForm()) {
                this.enviarMensaje();
            }
            else {
            }
        }
        else {
            // const params = {
            //   'pantalla': result,
            //   'datosForm': null};
            this.childModalClose.emit('cerrar');
        }
    }
    enviarMensaje() {
        if (this.componentNumber && this.componentNumber === ChildsMenuEnum.GESTION_TERCEROS) {
            this.sendMessageGestTer();
        }
        else {
            this.sendMessage();
        }
    }
    validateForm() {
        if (this.formSms.get('Phone').value !== '' && this.formSms.get('Description').value !== '') {
            return true;
        }
        this.formSms.get('Phone').markAsTouched();
        this.formSms.get('Description').markAsTouched();
        return false;
    }
    sendMessageGestTer() {
        const datosFormulario = this.formSms.getRawValue();
        const params = {
            CLIENTCODE: this.clientCode,
            COMPANYCODE: this.companyCode,
            SendTypeCode: 'DEFAULT',
            TemplateCode: 'DEFAULT',
            date: this.fechaActual,
            SMSSendDetailList: [{
                    CustomerCode: this.CustomerCodePhone,
                    TelephonePortable: datosFormulario.Phone,
                    Text: datosFormulario.Description
                }]
        };
        this._smsService.sendSms(params).subscribe(resp => {
            this.translateService.get('labels.successSms').subscribe(text => {
                this.toastr.success(text);
                this.childModalClose.emit('cerrar');
            });
        }, error => {
            this.error = error.error.ErrorMessage;
            this.code = error.error.ErrorCode;
            this.toastr.error(this.code, this.error);
            this.childModalClose.emit('cerrar');
        });
    }
    sendMessage() {
        const datosFormulario = this.formSms.getRawValue();
        const params = {
            CLIENTCODE: this.clientCode,
            // CLIENTCODE: this.customerId,
            COMPANYCODE: this.companyCode,
            SendTypeCode: 'DEFAULT',
            TemplateCode: 'DEFAULT',
            date: this.fechaActual,
            SMSSendDetailList: [{
                    // CustomerCode: this.CustomerCodePhone,
                    CustomerCode: this.CustomerCodePhone,
                    TelephonePortable: datosFormulario.Phone,
                    Text: datosFormulario.Description
                }]
        };
        this._smsService.sendSms(params).subscribe(resp => {
            if (resp.Response.Data) {
                this.translateService.get('labels.successSms').subscribe(text => {
                    this.toastr.success(text);
                    this.childModalClose.emit('cerrar');
                });
            }
            else {
                this.toastr.warning(resp.Warning.Content);
                this.childModalClose.emit('cerrar');
            }
        }, error => {
            this.error = error.error.ErrorMessage;
            this.code = error.error.ErrorCode;
            this.toastr.error(this.code, this.error);
            // const params = {
            // 'pantalla': 'modalPhone',
            // 'datosForm': null};
            this.childModalClose.emit('cerrar');
        });
    }
};
ModalPhoneComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [TranslateService,
        ToastrService,
        GlobalsService,
        AuthService,
        SmsService])
], ModalPhoneComponent);
export { ModalPhoneComponent };
